var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGameActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.1309L16.5 19.6309L23.5 21.6309L25 10.1309H20.5Z",
    fill: "url(#paint0_linear_538_14844)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.6309L4.5 19.6309L14.5 21.6309L16 10.6309H7.5Z",
    fill: "url(#paint1_linear_538_14844)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8336 7C24.8413 7 28.9009 11.0595 28.9009 16.0672C28.9009 20.9706 25.0087 24.9649 20.1454 25.1292L19.8336 25.1344H12.0672C7.05953 25.1344 3 21.0749 3 16.0672C3 11.1639 6.89215 7.16956 11.7555 7.00526L12.0672 7H19.8336ZM19.5126 16.7149C18.6183 16.7149 17.8934 17.4398 17.8934 18.334C17.8934 19.2283 18.6183 19.9532 19.5126 19.9532C20.4068 19.9532 21.1317 19.2283 21.1317 18.334C21.1317 17.4398 20.4068 16.7149 19.5126 16.7149ZM10.7692 12.1813C10.2773 12.1813 9.87087 12.5467 9.80654 13.0209L9.79768 13.1528V15.0931L7.8547 15.0941C7.31816 15.0941 6.88321 15.5291 6.88321 16.0656C6.88321 16.5574 7.24869 16.9639 7.72287 17.0282L7.8547 17.0371L9.79768 17.0361V18.9817C9.79768 19.5182 10.2326 19.9532 10.7692 19.9532C11.261 19.9532 11.6675 19.5877 11.7318 19.1135L11.7407 18.9817V17.0361L13.6836 17.0371C14.2202 17.0371 14.6551 16.6021 14.6551 16.0656C14.6551 15.5738 14.2896 15.1673 13.8155 15.103L13.6836 15.0941L11.7407 15.0931V13.1528C11.7407 12.6162 11.3057 12.1813 10.7692 12.1813ZM22.1032 12.1813C21.209 12.1813 20.484 12.9062 20.484 13.8004C20.484 14.6946 21.209 15.4196 22.1032 15.4196C22.9974 15.4196 23.7223 14.6946 23.7223 13.8004C23.7223 12.9062 22.9974 12.1813 22.1032 12.1813Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_14844",
    x1: 16.5,
    y1: 15.8809,
    x2: 25,
    y2: 15.8809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_14844",
    x1: 4.5,
    y1: 16.1309,
    x2: 16,
    y2: 16.1309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameActive);
export default __webpack_public_path__ + "static/media/icon_game_active.e5db39585d4b39ef4dd6b4a30bd24a93.svg";
export { ForwardRef as ReactComponent };